import { render } from "./modalInformacao.vue?vue&type=template&id=1700078e"
import script from "./modalInformacao.vue?vue&type=script&lang=js"
export * from "./modalInformacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__